import React from 'react';
import { ColStart, RowCenter, RowSpaceBetween } from '../Common/index';
import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import Snackbar from '@material-ui/core/Snackbar';

const thoughtIcon = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA2CAYAAACbZ/oUAAAAAXNSR0IArs4c6QAABJpJREFUaAXtWUtIVkEYNbOnEKH2hIS0aCEVpD0WSdSqoKBVi6AioqDa9MCQopAWtaig5yYiiCISXfQgCFslRklRC62gEkksAo3sAdm7c8SB6/TN/Pcx97Hwg/PfO998c+Y7d+bOnXv/vLxkrQnd/dXQmGQK+Ul2loW+hgVnYRTizGF4hOO8ulngDjLCQWKT1jbKdYdTQPgUWBOReDbaV2ooi8i5Ee3bAOboxEj0HODz8zsQVTQonBnF/gaYG3OMLNorVm0YsiLaK1blFkk07wtOFUXmPaYtWhKr8uOtF3q9sRGnJTpXTqshOJKZOugH68pIzOEar0Iz9q1GVB2dDoAuOi2x6hLpop2KVZ0o0UHFjgRBNXAEaABagNfAK6AZqAcOA0uAIPeeEh2LWOQyYBvw63cac4U/A/QCatrlOr5H7HGgGPBjFJ36Y3I8kqgDvgK5BJrq+9C2FhgNZNpmILsngElIUP99cE3OquLFSIxTMqioXPFvwDnPlegRjohmgacVKLLw/UHdA+AZ8A7gAjUNoJhFgC0XXsiFQDeQuk1ABtzSmUbqA+r2ApMAk1H4AeATYOJ5jLpxQOp2CRmYkryKuokBMixB7A0L3+kAXLGEzgerelvRRdf57LFQi+NUPwHofCz/AHj7pGZ30LOU2HkfGc1BzMPB9j04cmPjtWsoSNz13qAkz8sNCb2AP9cXCC5Q7Vp7zpRKQBmf512ALppxqTyq9gjJMLm1QC4zXayDWsNNKOuCWd6ixSVSbBaS6fTZMxcyPqZ0Mdu19tyHc7rrcTe1ON/FAkQ2WqJrUGcSUSW0uy74JFcfnCeB3Z7KDpxf9pR5yul7C9jMgsf4TDYZv5udM1XSr189b3mBoSEvlDdOna8zxJvc61FxAeBU5qhLthVOxa+OvBCmjQrXARX335GJh7ExhkbcQQUxPqcJm0mcfHQx95+2hlIdG4Yx3luS8Q3JtZk4TTlY+w8rmFNKsqmSM6LPxGnKwdodp8VdS8RnQx13PJKVSc6IvnKh/S/4TII/os62EAt0/lxdCNMXhdv+mgaKahH6aQvE4Cj4ipBIP3wljvhJUwpwJPULe5aVSdsKdKgnwvIph4mY3sS8W1CH3dmp+BzsAHTRvL+r7E191S5DlDS6/GchNduPnnXBLHcD0yNkxcVP2lKSe2cE3shNC8HwEpBEd8I/N0QP3Da+NXBydEeH4HTahN+juOORRH+Bfx8wFshlvHiHgG+AxEV/BZAJq0MWUpLKxyl+DKgGigBlxThZDvBFgh/qVLx03IX6zFg+MuGjQkpU8nG0+BeJVCf5jiI2k1aLrKT3XEmEHx9X6R2ZVOpJqgbnfsT4idnm4XVyyqno2todErrkGkgrDsE9DgW75HKY1lCqEhRd3MfcsWXin4ah8uRSK9x+7lFbTJNMHc0bx5RmRhejpTXQ2gWHgzT8URQgjB/kbSNoq3uEtqaPdP4ySCGqAn3yi4lNmFTXizZlKeTrpMulYOFKKwmTfHxpSOVd14naQZJSHBsASaDycVXnR3j+TxyrJXmfzIQSvjxwqvPRRbGcvm3APYAvGLHbPzPXVH8z9TJKAAAAAElFTkSuQmCC';
const introduction = 'https://flipboard-cn-static.oss-cn-hangzhou.aliyuncs.com/assets/hashtag-notification/introduction.png';

export const PageContainer = styled(ColStart)`
  align-items: center;
`;

export const BodyContainer = styled(ColStart)`
  align-items: center;
  max-width: 600px;
  background: #e7e7e7;
`;

export const HeaderContainer = styled(ColStart)`
  align-self: flex-start;
  margin: 80px 32px 0;
`;

export const NormalText = styled.div`
  line-height: 18px;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 1px;
`;

export const ThinText = styled.div`
  line-height: 18px;
  font-size: 12px;
  font-weight: 100;
  letter-spacing: 1px;
`;

export const BlackText = styled(NormalText)`
  color: #000;
`;

export const BlackTextWithMargin = styled(BlackText)`
  margin: 16px 0 0 0;
`;

export const WhiteText = styled(NormalText)`
  color: #fff;
`;

export const WhiteTextWithMargin = styled(WhiteText)`
  margin: 16px 0 0 0;
`;

export const UnderlineBlackText = styled(NormalText)`
  color: #000;
  padding: 0 0 2px 0;
  border-bottom: 10px solid #000;
`;

export const Title = styled(BlackText)`
  font-size: 70px;
  line-height: 66px;
  letter-spacing: 5.83px;
`;


export const RedRect = styled.div`
  width: 60px;
  height: 60px;
  background: #f52828;
  position: absolute;
`;

export const RedRectLT = styled(RedRect)`
  align-self: flex-start;
  top: 0;
  left: 0;
`;

export const RedRectRB = styled(RedRect)`
  align-self: flex-end;
  bottom: 0;
  right: 0;
`;

export const BlackBoard = styled.div`
  background: #000;
  padding: 24px;
  width: calc(100% - 24px);
`;

export const WhiteBoard = styled.div`
  background: #fff;
  padding: 24px;
  border: 10px solid #000;
  width: calc(100% - 48px);
`;

export const SectionContainer = styled(ColStart)`
  position: relative;
  top: 0;
  left: 0;
  z-index: 10;
  width: calc(100% - 64px);
`;

export const SectionBoxContainer = styled(ColStart)`
  width: calc(100% - 64px);
  margin: 64px 0 0;
  align-items: center;
  position: relative;
  top: 0;
  left: 0;
`;

export const HashTagContainer = styled(SectionContainer)`
  transform: rotate(-2deg);
`;

export const HashTagTitle = styled(Title)`
  align-self: flex-end;
  margin: 0 -22px 0 0;
`;

export const HashTagContent = styled(BlackBoard)`
  align-self: center;
`;

export const ThoughtTitleContainer = styled(RowCenter)`
  align-self: center;
  align-items: center;
`;

export const ThoughtTitleIcon = styled.img`
  width: 43px;
  height: 38px;
  margin: 0 18px 0;
`;

export const ThoughtContainer = styled(SectionContainer)`
  align-self: center;
  transform: rotate(1deg);
`;

export const ThoughtContent = styled(WhiteBoard)`
  align-self: center;
`;

export const RecommendorContainer = styled(SectionContainer)`
`;

export const RecommendorTitle = styled(Title)`
  align-self: flex-end;
  margin: 0 -24px 0;
`;

export const RecommendorContent = styled(WhiteBoard)`
  align-self: center;
`;

export const ContactTextConainer = styled(RowSpaceBetween)`
  margin: 20px 0;
  height: 40px;
  width: 100%;
`;

export const WhiteTextWithBackground = styled(WhiteText)`
  width: 50%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-family: '';
`; 

export const ContactText = styled(WhiteTextWithBackground)`
  background: #f52828;
`;

export const CopyButton = styled(WhiteTextWithBackground)`
  background: #000;
`;

export const ContactContainer = styled(ColStart)`
  margin: 64px 32px 0;
  width: calc(100 - 64px);
`;

export const SloganContainer = styled(ColStart)`
  margin: 64px 32px 0;
  width: calc(100% - 64px);
`;

export const SloganText = styled(BlackText)`
  font-size: 28px;
`;

export const TeamContainer = styled(ColStart)`
  margin: 64px 32px;
  align-self: flex-end;
  align-items: flex-end;
`;

export const ImageBox = styled.div`
  margin: 64px 0 0;
  width: calc(100% - 64px);
  /* padding-bottom:100%; */
`;

export const Image = styled.img`
	position:relative;
	top:0;
	bottom:0;
	left:0;
	right:0;
	width:100%;
	margin:auto;
`;

export const Tips = styled.div`
  padding: 10px 32px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  border-radius: 4px;
  color: #c3c3c3;
  background: #2b2b2b;
  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);
  position: relative;
  top: 20px;
`;

export const Header = () => {
  return (
    <HeaderContainer>
      <BlackText> {'不期而至'} </BlackText>
      <UnderlineBlackText> {'我们想跟大家聊聊这次的不同'} </UnderlineBlackText>
    </HeaderContainer>
  );
};

export const HashTag = () => {
  return (
    <SectionBoxContainer>
      <HashTagContainer>
        <HashTagTitle> {'小馆'} </HashTagTitle>
        <HashTagContent>
          <WhiteText> {'小馆是红板报全新的兴趣主题社区。'} </WhiteText>
          <WhiteTextWithMargin> {'我们相信，人与人之间交流碰擦出的火花，足以照亮每一间小馆。'} </WhiteTextWithMargin>
        </HashTagContent>
      </HashTagContainer>
      <RedRectLT style={{top: '48px'}}/>
      <RedRectRB style={{bottom: '-16px'}}/>
    </SectionBoxContainer>
  );
};

export const Thought = () => {
  return (
    <SectionBoxContainer>
      <ThoughtContainer>
        <ThoughtTitleContainer>
          <ThoughtTitleIcon src={thoughtIcon} alt={''} />
          <Title> {'想法'} </Title>
        </ThoughtTitleContainer>
        <ThoughtContent>
          <BlackText> {'想法是对你所知、所感、所珍藏的记录。'} </BlackText>
          <BlackTextWithMargin> {'好想法都是能产生共鸣与碰撞的伙石，而共鸣与碰撞，让世界更有趣！'} </BlackTextWithMargin>
          <ThinText style={{margin:'20px 0 0'}}> {'注：目前只有推荐人才能发布想法哦~'} </ThinText>
        </ThoughtContent>
      </ThoughtContainer>
      <RedRectLT style={{top:'42px'}}/>
      <RedRectRB style={{bottom: '-24px'}}/>
    </SectionBoxContainer>
  );
};

export const Recommendor = () => {
  return (
    <SectionBoxContainer>
      <RecommendorContainer>
        <RecommendorTitle> {'推荐人'} </RecommendorTitle>
        <RecommendorContent>
          <BlackText> {'推荐人是我们从各个领域邀请来分享交流的朋友。'} </BlackText>
          <BlackTextWithMargin> {'觉得不够酷？等你来踢馆！'} </BlackTextWithMargin>
        </RecommendorContent>
      </RecommendorContainer>
      <RedRectLT style={{top:'40px'}}/>
      <RedRectRB style={{bottom:'-20px'}}/>
    </SectionBoxContainer>
  );
};

export const Contact = (props) => {
  const { contact = '', onclick = () => {} } = props || {};
  return (
    <ContactContainer >
      <UnderlineBlackText> {'联系我们'} </UnderlineBlackText>
      <BlackTextWithMargin> {'如果你对成为推荐人感兴趣，或者对小馆有更好的建议、想看到新的小馆，请添加小助手微信：'} </BlackTextWithMargin>
      <ContactTextConainer onClick={() => onclick()}>
        <ContactText> {contact} </ContactText>
        <CopyButton> {'点我复制'} </CopyButton>
      </ContactTextConainer>
    </ContactContainer>
  )
};

export const Slogan = () => {
  return (
    <SloganContainer>
      <BlackText> {'小馆，让观点与情绪交错'} </BlackText>
      <SloganText style={{margin:'32px 0 0'}}> {'酷想法，放开说！'} </SloganText>
    </SloganContainer>
  );
}

export const Team = (props) => {
  return (
    <TeamContainer>
      <UnderlineBlackText> {'红板报团队'} </UnderlineBlackText>
      <UnderlineBlackText style={{margin:'12px 0 0'}}> {'敬上'} </UnderlineBlackText>
    </TeamContainer>
  );
};



export const Opening = () => {
  const contact = 'chunji3022';

  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;

  const handleClick = newState => () => {
    copy(contact);
    setState({ open: true, ...newState });
  };

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  return (
    <PageContainer>
      <BodyContainer>
        <Header />
        <ImageBox>
          <Image src={introduction} alt={''} />
        </ImageBox>
        <Contact
          contact={contact}
          onclick={handleClick({ vertical: 'top', horizontal: 'center' })} />
        <Slogan />
        <Team />
      </BodyContainer>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        key={`${vertical},${horizontal}`}
        open={open}
        onClose={handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        // message={<span id="message-id">复制成功</span>}
      >
        <Tips> {'复制成功'} </Tips>
      </Snackbar>
    </PageContainer>
  );
};

export default {};
